module.exports = __webpack_public_path__ + "img/alibi-logo-white.a39db3b1.png";